"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var link_1 = require("spry-react/Link/link");
function DialogSingleTab(props) {
    return React.createElement("nav", { className: "dialog-tab-strip" },
        React.createElement("ul", null,
            React.createElement("li", { className: "dialog-tab-strip-selected" },
                React.createElement(link_1.Link, { onClick: null }, props.text))));
}
exports.DialogSingleTab = DialogSingleTab;
